module.exports = __webpack_public_path__ + "static/media/djpayback-banner.7b74fed1.jpg";